import React, { useEffect, useState } from "react";
import "./selectbox.css";

function SelectBox(props) {
  console.log(props);
  const [optionsToRender, setOptionsToRender] = useState([]);

  useEffect(() => {
    if (props?.options) {
      console.log(props?.options);
      setOptionsToRender(props.options);
    }
  }, [props.options]);

  function handleSelectValue(data) {
    console.log(data, "line 16");
    props.selectValue(data);
  }

  const renderCountry = optionsToRender.map((perOption) => {
    return (
      <option key={Math.random()} value={perOption.optionValue}>
        {perOption.optionName}
      </option>
    );
  });

  return (
    <div className="select_input_text_contianer">
      <p className="select_label_text">{props.headTextInput}</p>
      <select
        name="pets"
        id="pet-select"
        className="select_box_"
        onChange={(e) => handleSelectValue(e.target.value)}
      >
        <option>{props.initialValue}</option>

        {optionsToRender.length > 0 ? renderCountry : null}
      </select>
    </div>
  );
}

export default SelectBox;
